import { createRoot } from '@wordpress/element';
import { useIsMobile } from '../hooks/useMediaQuery';

/**
 * ImageBanner Component - Frontend React component
 * Shows desktop or mobile image based on screen size
 */
function ImageBanner({ imageUrl, imageUrlMobile, alt, url }) {
  const isMobile = useIsMobile();
  
  // Determine which image to show
  const currentImage = isMobile && imageUrlMobile ? imageUrlMobile : imageUrl;
  
  // Don't render if no image
  if (!currentImage) return null; 

  // Create image element
  const imageElement = (
    <img 
      src={currentImage} 
      alt={alt || ''} 
      className="image-banner__img"
    />
  );

  // Wrap in link if url is provided
  return url ? (
    <a href={url} className="image-banner__link">
      {imageElement}
    </a>
  ) : (
    imageElement
  );
}

/**
 * Initialize all image banner blocks on the page
 */
function init() {
  // Find all image-banner blocks
  const blocks = document.querySelectorAll('.wp-block-papa-lp-image-banner');
  
  blocks.forEach((block) => {
    // Skip if already initialized
    if (block.dataset.initialized === '1') return;
    
    try {
      // Parse attributes from data attribute
      const props = JSON.parse(block.dataset.bannerProps);
      
      // Mark as initialized
      block.dataset.initialized = '1';
      
      // Hydrate React component
      const root = createRoot(block);
      root.render(<ImageBanner {...props} />);
    } catch (error) {
      console.error('Error initializing image banner:', error);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Export for manual re-initialization (e.g., after AJAX content load)
window.PapaLpImageBannerInit = init;

